import type { ReactNode } from "react";
import { useNavigate } from "react-router-dom";
import { EntitlementDeniedState, LoadingState } from "@odingard/design-system";
import { useAuth } from "../lib/auth";
import { useAsync } from "../lib/useAsync";
import { api } from "../lib/api";

export const MEETING_ENTITLEMENT = "meeting_ai.enabled";

export function hasMeetingEntitlement(entitlements: { key: string; status: string }[] | null): boolean {
  return entitlements?.some((item) => item.key === MEETING_ENTITLEMENT && ["ALLOWED", "TRIAL"].includes(item.status)) ?? false;
}

export function MeetingGuard({ children }: { children: ReactNode }) {
  const { activeOrg } = useAuth();
  const navigate = useNavigate();
  const orgId = activeOrg?.id ?? "";
  const state = useAsync(async () => (await api.entitlements(orgId)).entitlements, [orgId]);
  if (state.loading) return <LoadingState label="Checking Meeting AI access…" />;
  if (!hasMeetingEntitlement(state.data)) {
    return <EntitlementDeniedState product="Meeting AI" onUpgrade={() => navigate("/pricing")} />;
  }
  return <>{children}</>;
}
